"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var Bar = function Bar(_ref) {
  var value = _ref.value,
      valueOutput = _ref.valueOutput,
      valueThreshold = _ref.valueThreshold,
      ratio = _ref.ratio,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: 'HorizontalBar',
    style: {
      width: "".concat(ratio * 100, "%")
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "value ".concat(ratio < valueThreshold ? 'right' : '')
  }, valueOutput || value)));
};

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var HorizontalBarChart = function HorizontalBarChart(_ref2) {
  var data = _ref2.data,
      className = _ref2.className,
      _ref2$valueThreshold = _ref2.valueThreshold,
      valueThreshold = _ref2$valueThreshold === void 0 ? 0.25 : _ref2$valueThreshold,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["data", "className", "valueThreshold"]);
  var classes = useStyles();
  var maxValue = data.reduce(function (maximum, barData) {
    return Math.max(maximum, barData.value);
  }, -Infinity);
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.HorizontalChart, className)
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: 'Labels'
  }, data.map(function (barData) {
    return /*#__PURE__*/React.createElement("div", {
      key: barData.label
    }, barData.label);
  })), /*#__PURE__*/React.createElement("div", {
    className: 'Chart'
  }, data.map(function (barData, index) {
    return /*#__PURE__*/React.createElement(Bar, {
      key: index,
      valueThreshold: valueThreshold,
      className: classes.HorizontalBarWrapper,
      value: barData.value,
      valueOutput: barData.valueOutput,
      ratio: maxValue > 0 ? barData.value / maxValue : 0
    });
  })));
};

var _default = HorizontalBarChart;
exports["default"] = _default;
//# sourceMappingURL=index.js.map